import React, { useEffect } from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Pagination } from '@guildeducationinc/recess';
import { usePagination } from 'react-instantsearch-hooks-web';
import styles from './CustomPagination.module.scss';

export const ResultsPagination: React.FC = () => {
	const { currentRefinement, nbPages, refine } = usePagination();

	/**
	 * once this component is mounted we need to
	 * trigger a search to maintain the correct page
	 */
	useEffect(() => {
		refine(currentRefinement);
	}, [currentRefinement, refine]);

	// The current page is stored on a 0 based index, and we want to transform to a 1 based index for display
	const currentPage = currentRefinement + 1;
	const isMobile = useIsMobile();

	return nbPages !== 0 ? (
		<Pagination
			className={isMobile ? styles.mobilePagination : styles.desktopPagination}
			currentPage={currentPage}
			onChangePage={number => {
				refine(number - 1);
			}}
			testid='program-results-pagination'
			totalPages={nbPages}
		/>
	) : null;
};
